const createPagesMap = ({path, pageNames, prefix, specialCases = {}}) =>
    pageNames.reduce((map, pageName) => {
        map[`${path}${pageName}`] = specialCases[pageName] ? specialCases[pageName] : `${prefix}-${pageName}`;
        return map;
    }, {});

export const membershipPagesPaths = {
    postBooking: 'prime/postbooking/landing/',
    retention: 'prime/retention/',
    referral: '/referral-program/',
    referralInvite: '/referral-program/invite-friends/',
    referralError: '/referral-program/error/',
    standalone: '/BF/prime/standalone/',
};

const membershipRetentionPrefix = 'prime-retention';
const referralPrefix = 'prime-referral';

export const membershipPagesMap = {
    ...createPagesMap({
        path: membershipPagesPaths.postBooking,
        pageNames: ['error', 'success', 'processing', 'token-expired'],
        prefix: 'pb-standalone',
    }),
    ...createPagesMap({
        path: membershipPagesPaths.standalone,
        pageNames: [
            '3dsecure/',
            'link-3dsecure/',
            'unsuccess-3dsecure/',
            'rejected-3dsecure/',
        ],
        prefix: 'prime-standalone',
    }),
    ...createPagesMap({
        path: membershipPagesPaths.referral,
        pageNames: [
            'invite-confirmation/',
            'invite-friends/',
            'invite-recommendations',
            'invite-form/',
            'invite-code-verify/',
            'invite-code-verify-error/',
        ],
        prefix: referralPrefix,
    }),
    ...createPagesMap({
        path: membershipPagesPaths.referralInvite,
        pageNames: ['how-it-works/'],
        prefix: referralPrefix,
    }),
    ...createPagesMap({
        path: membershipPagesPaths.referralError,
        pageNames: ['token-expired/', 'processing/', 'error/', 'something-error-email/'],
        prefix: referralPrefix,
    }),
    ...createPagesMap({
        path: membershipPagesPaths.retention,
        pageNames: [
            'membership-retention-funnel',
            'cancellation-success',
            'cancellation-success/full-refund',
            'cancellation-success/stopped',
            'days-left',
            'full-refund-form',
            'joker-page',
            'manage-subscription',
            'partial-cancellation-form',
            'reactivate-prime',
            'remind-me-later',
            'reminder-scheduled',
            'voucher',
            'voucher-accepted',
            'warning',
            'warning-losing-benefits',
            'welcome-back-prime',
            'all-benefits',
            'exclusive-benefits',
        ],
        prefix: membershipRetentionPrefix,
        specialCases: {
            'cancellation-success/stopped': `${membershipRetentionPrefix}-cancellation-success-stopped`,
            'cancellation-success/full-refund': `${membershipRetentionPrefix}-cancellation-success-full-refund`,
        },
    }),
};
